/** Shopify CDN: Minification failed

Line 19:172 Expected "}" but found ";"

**/

// AI_QUIZ_LIST_ADDED_2026 — also subscribe quiz takers to AI Quiz Subs list
window.__addToAIQuizList = function(email, props) {
  try {
    if (!email || email.indexOf('@') < 0) return;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RBXcQk', {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'LMM AI Quiz - LuxeBeam',
            profile: { data: { type: 'profile', attributes: { email: email, properties: Object.assign({}, props || {}, { quiz_subscriber_source: 'lmm-skin-consultant-quiz' }) } } }
          },
          relationships: { list: { data: { type: 'list', id: 'VQtBtT' } } }
        }
      })
    }).then(function(r){ console.log('[ai-quiz:list-add]', r.status); }).catch(function(e){ console.warn('[ai-quiz:list-add]', e); });
  } catch(e) { console.warn('[ai-quiz:list-add]', e); }
};
/* ========================================================================
   AI Quiz · Shopify Theme Asset — ai-quiz.js
   Reads quiz/ack/branch config from section DOM, runs quiz state machine,
   personalizes dossier sections, reveals them on same-page flow.
   ======================================================================== */
(function () {
  'use strict';

  const state = {
    step: -1, answers: {}, multiSelect: [], activeChipsEl: null, email: null,
    faqAnswered: new Set(), typingAbort: false, introMessages: [],
    questions: [], acks: {}, interstitials: {}, resultsRevealed: false,
  };

  // Fixed structural schema — keys locked in code, text editable via blocks
  const QUESTION_SCHEMA = [
    { id: 'concerns', type: 'multi', max: 3, keys: ['fine_lines','firmness','dullness','texture','redness','dark_spots','prevention'] },
    { id: 'age', type: 'single', keys: ['u35','35_44','45_54','55p'] },
    { id: 'routine', type: 'single', keys: ['minimal','basic','serious','pro'] },
    { id: 'tried', type: 'single', keys: ['minimal_tried','drugstore','premium_serums','actives','facials','injectables','devices'] },
    { id: 'conditions', type: 'single', keys: ['none','sensitive','rosacea','melasma','recent_tx'] },
    { id: 'consistency', type: 'single', keys: ['daily','weekly3','weekends','simple'] },
    { id: 'hesitation', type: 'single', keys: ['price','burned','works','push'] },
  ];

  let streamEl, canvasEl, widgetEl;

  // ======== WeTracked custom event tracking ========
  // Uses wtq('track', { event, ...props }) from events.js
  // Wrapped in try/catch so ad blockers don't break the quiz
  function wtqTrack(eventName, props) {
    try {
      if (typeof wtq === 'function') {
        wtq('track', Object.assign({ event: eventName }, props || {}));
      } else if (window['wt:queue']) {
        window['wt:queue'].push(['track', Object.assign({ event: eventName }, props || {})]);
      }
    } catch (e) {
      console.warn('[wt] event failed:', eventName, e);
    }
  }
  function getWtEventBase() {
    var p = new URLSearchParams(location.search);
    return {
      utm_source: p.get('utm_source') || '',
      utm_campaign: p.get('utm_campaign') || '',
      page_url: location.href
    };
  }

  // ======== Data ingestion from DOM ========
  function readQuizConfig() {
    widgetEl = document.getElementById('aiqWidget');
    if (!widgetEl) return false;
    streamEl = document.getElementById('aiqStream');
    canvasEl = document.getElementById('aiqCanvas');

    // Intro messages
    const introBlocks = widgetEl.querySelectorAll('[data-aiq-intro-msg]');
    state.introMessages = Array.from(introBlocks).map(el => el.innerHTML.trim()).filter(Boolean);

    // Questions — merge schema with block-defined copy
    state.questions = QUESTION_SCHEMA.map(schema => {
      const qBlock = widgetEl.querySelector(`[data-aiq-question="${schema.id}"]`);
      const prompt = qBlock?.dataset.prompt || qBlock?.querySelector('[data-aiq-prompt]')?.innerHTML.trim() || '';
      const hint = qBlock?.dataset.hint || '';
      const options = schema.keys.map(k => {
        const optEl = qBlock?.querySelector(`[data-aiq-option="${k}"]`);
        return { k, v: optEl?.textContent.trim() || '' };
      }).filter(o => o.v);
      return { ...schema, prompt, hint, options };
    });

    // Acks keyed by "stepIdx.answerKey"
    widgetEl.querySelectorAll('[data-aiq-ack]').forEach(el => {
      state.acks[el.dataset.aiqAck] = el.innerHTML.trim();
    });
    widgetEl.querySelectorAll('[data-aiq-interstitial]').forEach(el => {
      state.interstitials[el.dataset.aiqInterstitial] = el.innerHTML.trim();
    });
    __wireAutoscrollPause();
    return true;
  }

  // ======== Primitives ========
  function appendNode(node) { streamEl.appendChild(node); scrollBottom(); }

  /* ─── Slow, consistent autoscroll (60px/sec). Pauses on touch/wheel/key. Resumes 1.5s after last interaction. ─── */
  var __autoscrollState = { active: false, lastInteraction: 0, rafId: null, lastTs: 0 };
  function __pauseAutoscroll() { __autoscrollState.lastInteraction = Date.now(); }
  function __wireAutoscrollPause() {
    if (!canvasEl) return;
    ['touchstart','touchmove','wheel','mousedown','keydown'].forEach(function(ev){
      canvasEl.addEventListener(ev, __pauseAutoscroll, { passive: true });
    });
  }
  function __autoscrollTick(ts) {
    if (!__autoscrollState.active) return;
    if (Date.now() - __autoscrollState.lastInteraction < 1500) {
      __autoscrollState.lastTs = ts;
      __autoscrollState.rafId = requestAnimationFrame(__autoscrollTick);
      return;
    }
    var dt = __autoscrollState.lastTs ? (ts - __autoscrollState.lastTs) / 1000 : 0;
    __autoscrollState.lastTs = ts;
    var pixelsPerSec = 60;
    var step = Math.max(0, dt) * pixelsPerSec;
    var maxScroll = canvasEl.scrollHeight - canvasEl.clientHeight;
    if (canvasEl.scrollTop < maxScroll) {
      canvasEl.scrollTop = Math.min(maxScroll, canvasEl.scrollTop + step);
    }
    __autoscrollState.rafId = requestAnimationFrame(__autoscrollTick);
  }
  function scrollBottom() {
    /* Trigger autoscroll instead of jump */
    __autoscrollState.active = true;
    __autoscrollState.lastTs = 0;
    if (!__autoscrollState.rafId) {
      __autoscrollState.rafId = requestAnimationFrame(__autoscrollTick);
    }
  }
  function aiMessage(html) {
    const d = document.createElement('div');
    d.className = 'aiq-msg aiq-msg-ai';
    d.innerHTML = `<div class="aiq-msg-avatar"></div><div class="aiq-bubble">${html}</div>`;
    return d;
  }
  function userMessage(text) {
    const d = document.createElement('div');
    d.className = 'aiq-msg aiq-msg-user';
    d.innerHTML = `<div class="aiq-bubble">${text}</div>`;
    return d;
  }
  function typingBubble() {
    const d = document.createElement('div');
    d.className = 'aiq-msg aiq-msg-ai aiq-typing-msg';
    d.innerHTML = `<div class="aiq-msg-avatar"></div><div class="aiq-typing-bubble"><span class="aiq-dot"></span><span class="aiq-dot"></span><span class="aiq-dot"></span></div>`;
    return d;
  }
  function removeTyping() { const t = streamEl.querySelector('.aiq-typing-msg'); if (t) t.remove(); }
  function showTyping() { removeTyping(); appendNode(typingBubble()); }
  function removeChips() { if (state.activeChipsEl) { state.activeChipsEl.remove(); state.activeChipsEl = null; } }
  const sleep = ms => new Promise(r => setTimeout(r, ms));

  // ======== Chips ========
  function renderChips(q) {
    removeChips();
    const wrap = document.createElement('div');
    wrap.className = 'aiq-chips-wrap';
    if (q.hint) {
      const h = document.createElement('div');
      h.className = 'aiq-chips-hint';
      h.textContent = q.hint;
      wrap.appendChild(h);
    }
    const chipsEl = document.createElement('div');
    chipsEl.className = 'aiq-chips';
    q.options.forEach(opt => {
      const chip = document.createElement('button');
      chip.className = 'aiq-chip';
      chip.textContent = opt.v;
      chip.dataset.k = opt.k;
      chip.onclick = () => handleSelect(q, opt, chip);
      chipsEl.appendChild(chip);
    });
    if (q.type === 'multi') {
      const btn = document.createElement('button');
      btn.className = 'aiq-chip aiq-chip-action';
      btn.id = 'aiqMultiNext';
      btn.disabled = true;
      btn.textContent = 'Continue →';
      btn.onclick = () => commitMulti(q);
      chipsEl.appendChild(btn);
    }
    wrap.appendChild(chipsEl);
    streamEl.appendChild(wrap);
    state.activeChipsEl = wrap;
    scrollBottom();
  }

  function handleSelect(q, opt, chip) {
    if (q.type === 'single') {
      state.answers[q.id] = opt.k;
      // WeTracked: fire quiz_started on first question commit
      if (state.step === 0) {
        wtqTrack('quiz_started', getWtEventBase());
      }
      // WeTracked: fire per-question completion
      wtqTrack('quiz_question_completed', Object.assign({
        question_id: q.id,
        question_number: state.step + 1,
        answer_value: opt.k
      }, getWtEventBase()));
      removeChips();
      appendNode(userMessage(opt.v));
      setTimeout(advance, 400);
    } else {
      const idx = state.multiSelect.indexOf(opt.k);
      if (idx >= 0) { state.multiSelect.splice(idx, 1); chip.classList.remove('aiq-selected'); }
      else { if (state.multiSelect.length >= q.max) return; state.multiSelect.push(opt.k); chip.classList.add('aiq-selected'); }
      const btn = document.getElementById('aiqMultiNext');
      if (btn) btn.disabled = state.multiSelect.length === 0;
    }
  }

  function commitMulti(q) {
    state.answers[q.id] = [...state.multiSelect];
    // WeTracked: fire quiz_started on first question commit (Q1 is multi-select)
    if (state.step === 0) {
      wtqTrack('quiz_started', getWtEventBase());
    }
    // WeTracked: fire per-question completion
    wtqTrack('quiz_question_completed', Object.assign({
      question_id: q.id,
      question_number: state.step + 1,
      answer_value: state.multiSelect.join(',')
    }, getWtEventBase()));
    const summary = state.multiSelect.map(k => q.options.find(o => o.k === k).v).join(', ');
    removeChips();
    appendNode(userMessage(summary));
    state.multiSelect = [];
    setTimeout(advance, 400);
  }

  // ======== Ack lookup ========
  function generateAck(stepIdx, answers) {
    const qIdx = stepIdx - 1;
    const q = QUESTION_SCHEMA[qIdx];
    if (!q) return '';
    let answerKey = q.type === 'multi' ? (answers[q.id]?.[0] || '') : (answers[q.id] || '');
    return state.acks[`${stepIdx}.${answerKey}`] || state.acks[`${stepIdx}.default`] || '';
  }

  // ======== Flow ========
  function updateProgress() {
    const total = state.questions.length + 1;
    const current = state.step < 0 ? 0 : state.step + 1;
    const fill = document.getElementById('aiqProgressFill');
    if (fill) fill.style.width = Math.min(100, (current / total) * 100) + '%';
  }


  // ======== Chat image insertion (live flow) ========
  function insertChatImagesForStep(afterStep) {
    if (!widgetEl) return;
    const imgs = widgetEl.querySelectorAll('[data-aiq-chat-image][data-aiq-chat-after-step="' + afterStep + '"]');
    imgs.forEach(imgEl => {
      const src = imgEl.dataset.aiqChatImage;
      const caption = imgEl.dataset.aiqChatCaption || '';
      if (!src) return;
      const div = document.createElement('div');
      div.className = 'aiq-msg aiq-msg-image';
      div.innerHTML = '<div class="aiq-msg-avatar"></div><div><img src="' + src + '" alt="' + caption + '" />' + (caption ? '<div class="aiq-msg-image-caption">' + caption + '</div>' : '') + '</div>';
      appendNode(div);
    });
  }

  function advance() {
    state.step++;
    updateProgress();
    // Images tagged after_step == current step render before next question
    insertChatImagesForStep(state.step);
    if (state.step >= state.questions.length) {
      const q7ack = generateAck(7, state.answers);
      if (q7ack) {
        setTimeout(() => showTyping(), 400);
        setTimeout(() => {
          removeTyping();
          appendNode(aiMessage(q7ack));
          setTimeout(askEmail, 2400);
        }, 1600);
      } else {
        setTimeout(askEmail, 500);
      }
      return;
    }
    askQuestion(state.step);
  }

  function askQuestion(stepIdx) {
    const q = state.questions[stepIdx];
    const ack = stepIdx > 0 ? generateAck(stepIdx, state.answers) : null;
    const interstitial = state.interstitials[stepIdx];
    const isRich = stepIdx >= 1 && stepIdx <= 4;
    const ackRead = isRich ? 2400 : 1100;
    const ackType = isRich ? 1800 : 1200;

    if (ack) {
      setTimeout(showTyping, 300);
      setTimeout(() => {
        removeTyping();
        appendNode(aiMessage(ack));
        if (interstitial) {
          setTimeout(showTyping, ackRead);
          setTimeout(() => {
            removeTyping();
            appendNode(aiMessage(interstitial));
            setTimeout(() => {
              showTyping();
              setTimeout(() => {
                removeTyping();
                appendNode(aiMessage(q.prompt));
                setTimeout(() => renderChips(q), 280);
              }, 2000);
            }, 2400);
          }, 2000);
        } else {
          setTimeout(showTyping, ackRead);
          setTimeout(() => {
            removeTyping();
            appendNode(aiMessage(q.prompt));
            setTimeout(() => renderChips(q), 280);
          }, ackRead + 1300);
        }
      }, ackType);
    } else {
      setTimeout(showTyping, 300);
      setTimeout(() => {
        removeTyping();
        appendNode(aiMessage(q.prompt));
        setTimeout(() => renderChips(q), 280);
      }, 2100);
    }
  }

  // ======== Email ========
  function askEmail() {
    setTimeout(showTyping, 300);
    setTimeout(() => {
      removeTyping();
      appendNode(aiMessage(widgetEl.dataset.emailPrompt || "Okay — compiling your customized routine. Where should we email the insider code? That way it's saved in your inbox even if you close this tab."));
      setTimeout(showTyping, 900);
      setTimeout(() => {
        removeTyping();
        appendNode(aiMessage(widgetEl.dataset.emailBonus || "You'll also get a bonus — <em>5 ingredients that secretly mess with LED therapy results.</em>"));
        setTimeout(renderEmailCapture, 800);
      }, 2400);
    }, 1200);
  }

  function renderEmailCapture() {
    // WeTracked: email gate shown
    wtqTrack('quiz_email_gate_shown', Object.assign({
      questions_answered_count: Object.keys(state.answers).length
    }, getWtEventBase()));
    removeChips();
    const wrap = document.createElement('div');
    wrap.className = 'aiq-chips-wrap';
    const form = document.createElement('div');
    form.className = 'aiq-email-form';
    form.innerHTML = `<input type="email" id="aiqEmailField" placeholder="you@example.com" autocomplete="email" /><button id="aiqEmailSubmit" disabled>Send it</button>`;
    wrap.appendChild(form);
    const skipRow = document.createElement('div');
    skipRow.className = 'aiq-chips';
    skipRow.style.marginTop = '8px';
    skipRow.innerHTML = `<button class="aiq-chip aiq-chip-skip" id="aiqEmailSkip">Skip — show my results now</button>`;
    wrap.appendChild(skipRow);
    streamEl.appendChild(wrap);
    state.activeChipsEl = wrap;
    scrollBottom();
    const field = document.getElementById('aiqEmailField');
    const submit = document.getElementById('aiqEmailSubmit');
    field.addEventListener('input', () => { submit.disabled = !/.+@.+\..+/.test(field.value); });
    field.addEventListener('keydown', e => { if (e.key === 'Enter' && !submit.disabled) handleEmailSubmit(field.value); });
    submit.onclick = () => handleEmailSubmit(field.value);
    document.getElementById('aiqEmailSkip').onclick = handleEmailSkip;
  }

  function handleEmailSubmit(email) {
    state.email = email;
    removeChips();
    appendNode(userMessage(email));
    fireTracking('email_capture', { email, answers: state.answers });
    setTimeout(showTyping, 400);
    setTimeout(() => {
      removeTyping();
      appendNode(aiMessage("Perfect. Compiling your results now..."));
      setTimeout(goAnalyze, 1400);
    }, 1300);
  }

  function handleEmailSkip() {
    removeChips();
    appendNode(userMessage("Skip"));
    setTimeout(showTyping, 400);
    setTimeout(() => {
      removeTyping();
      appendNode(aiMessage("No problem. Compiling your results now..."));
      setTimeout(goAnalyze, 1400);
    }, 1300);
  }

  // ======== Analyzing → Reveal ========
  function goAnalyze() {
    document.body.classList.add('aiq-analyzing');
    const stage = document.getElementById('aiqAnalyzingStage');
    if (stage) stage.classList.add('aiq-active');
    const steps = stage?.querySelectorAll('.aiq-step') || [];
    steps.forEach((s, i) => setTimeout(() => s.classList.add('aiq-show'), 450 * (i + 1)));
    setTimeout(revealDossier, 600 + (steps.length * 450));
  }

  function revealDossier() {
    try {
      localStorage.setItem('aiq_answers', JSON.stringify(state.answers));
      localStorage.setItem('aiq_email', state.email || '');
    } catch (e) {}
    personalizeAllSections();
    document.body.classList.remove('aiq-analyzing');
    document.body.classList.add('aiq-results-revealed');
    state.resultsRevealed = true;
    fireTracking('dossier_revealed', state.answers);
    const hero = document.querySelector('[data-aiq-section="hero"]');
    if (hero) setTimeout(() => hero.scrollIntoView({ behavior: 'smooth', block: 'start' }), 400);
    startTimer();
  }

  // ======== Personalization ========
  function personalizeAllSections() {
    document.querySelectorAll('[data-aiq-dossier]').forEach(section => {
      const id = section.dataset.aiqSection;
      switch (id) {
        case 'profile': personalizeProfile(section); break;
        case 'rootcause': personalizeBranch(section, 'concerns', true); break;
        case 'consequences': personalizeBranch(section, 'age', false); break;
        case 'mechanism': personalizeMechanism(section); break;
        case 'reveal': personalizeReveal(section); break;
        case 'cta': personalizeCTA(section); break;
        case 'testimonials': personalizeTestimonials(section); break;
      }
    });
  }

  function personalizeProfile(section) {
    const a = state.answers;
    const concernLabels = (a.concerns || []).map(k => {
      const opt = state.questions[0]?.options.find(o => o.k === k);
      return opt ? opt.v.toLowerCase() : k;
    }).join(', ');
    const ageLabel = { 'u35': 'under 35', '35_44': 'in the 35-44 bracket', '45_54': 'in the 45-54 bracket', '55p': '55 or older' }[a.age] || '';
    const routineLabel = { 'minimal': 'keeping your routine minimal', 'basic': 'on solid skincare basics', 'serious': 'running a full actives arsenal', 'pro': 'already using professional treatments' }[a.routine] || '';
    const bodyEl = section.querySelector('[data-aiq-profile-body]');
    if (bodyEl) {
      bodyEl.innerHTML = bodyEl.innerHTML
        .replaceAll('[AGE]', ageLabel)
        .replaceAll('[ROUTINE]', routineLabel)
        .replaceAll('[CONCERNS]', concernLabels);
    }
  }

  function personalizeBranch(section, answerField, useFirstOfArray) {
    let key = state.answers[answerField];
    if (useFirstOfArray && Array.isArray(key)) key = key[0];
    if (!key) return;
    const branches = section.querySelectorAll('[data-aiq-branch]');
    let matched = null;
    branches.forEach(br => { if (br.dataset.aiqBranch === key) matched = br; else br.style.display = 'none'; });
    if (matched) { matched.style.display = ''; matched.removeAttribute('hidden'); }
    else if (branches.length) { branches[0].style.display = ''; } // fallback to first
  }

  function personalizeMechanism(section) {
    const a = state.answers;
    const sess = (a.conditions === 'sensitive' || a.conditions === 'rosacea') ? '8 minutes' : '10 minutes';
    const freq = { 'daily': '5-7 times per week', 'weekly3': '3-4 times per week', 'weekends': '3 times per week', 'simple': '3 times per week' }[a.consistency] || '3-4 times per week';
    const timing = a.conditions === 'recent_tx' ? 'Week 4-6' : 'Week 3-4';
    section.innerHTML = section.innerHTML
      .replaceAll('[SESSION_LENGTH]', sess)
      .replaceAll('[FREQUENCY]', freq)
      .replaceAll('[TIMING]', timing);
  }

  function personalizeReveal(section) {
    // Nothing personalized — reveal content is the same for everyone
  }

  function personalizeCTA(section) {
    const hes = state.answers.hesitation;
    const branches = section.querySelectorAll('[data-aiq-hesitation]');
    branches.forEach(br => { if (br.dataset.aiqHesitation !== hes) br.style.display = 'none'; });
  }

  function personalizeTestimonials(section) {
    const a = state.answers;
    const concerns = a.concerns || [];
    const cards = Array.from(section.querySelectorAll('[data-aiq-testimonial]'));
    cards.forEach(card => {
      const tags = (card.dataset.aiqTags || '').split(',').map(s => s.trim());
      let score = 0;
      if (a.conditions === 'rosacea' && tags.includes('redness')) score += 10;
      if (a.conditions === 'sensitive' && tags.includes('redness')) score += 10;
      if (concerns.includes('dark_spots') && tags.includes('dark_spots')) score += 10;
      if (a.tried === 'devices' && tags.includes('premium')) score += 10;
      if (a.hesitation === 'price' && tags.includes('price')) score += 8;
      if (a.hesitation === 'works' && tags.includes('skeptical')) score += 8;
      if (concerns.includes('fine_lines') && tags.includes('lines')) score += 5;
      if (concerns.includes('dullness') && tags.includes('dullness')) score += 5;
      if (concerns.includes('firmness') && tags.includes('firmness')) score += 5;
      card.dataset.aiqScore = score;
      if (score >= 8) {
        const tag = document.createElement('span');
        tag.className = 'aiq-t-match-tag';
        tag.textContent = 'Matches your profile';
        card.appendChild(tag);
      }
    });
    // Sort by score descending — DOM reorder
    cards.sort((a, b) => parseInt(b.dataset.aiqScore || '0') - parseInt(a.dataset.aiqScore || '0'));
    const container = cards[0]?.parentElement;
    if (container) cards.forEach(c => container.appendChild(c));
  }

  // ======== CTA routing ========
  window.aiqHandleCTA = function (bundle) {
    const ctaSection = document.querySelector('[data-aiq-section="cta"]');
    if (!ctaSection) return;
    const cfg = ctaSection.dataset;
    const variantId = bundle === 'essential-nocode' ? cfg.variantEssential : cfg.variantPrimary;
    const discount = bundle === 'essential-nocode' ? '' : cfg.discountCode;
    const params = new URLSearchParams();
    if (state.email) params.set('checkout[email]', state.email);
    if (discount) params.set('discount', discount);
    const cartUrl = `https://${cfg.shopDomain}/cart/${variantId}:1?${params.toString()}`;
    fireTracking('cta_clicked', { bundle, variantId, discount });
    window.open(cartUrl, '_blank');
  };

  // ======== Urgency timer ========
  function startTimer() {
    const banner = document.getElementById('aiqUrgencyBanner');
    if (!banner) return;
    banner.style.display = 'flex';
    let seconds = 15 * 60;
    const el = document.getElementById('aiqTimer');
    const interval = setInterval(() => {
      seconds--;
      if (seconds <= 0) {
        clearInterval(interval);
        banner.innerHTML = 'The insider hold expired. Refresh to try again.';
        return;
      }
      const m = Math.floor(seconds / 60);
      const s = (seconds % 60).toString().padStart(2, '0');
      if (el) el.textContent = `${m}:${s}`;
    }, 1000);
  }

  // ======== Tracking ========
  var KLAVIYO_COMPANY_ID = 'RBXcQk';
  var KLAVIYO_LIST_ID = 'SxugG2';

  var CONCERN_DISPLAY = {
    fine_lines: 'fine lines', firmness: 'firmness', dullness: 'dullness & glow',
    texture: 'texture', redness: 'redness', dark_spots: 'dark spots', prevention: 'prevention'
  };
  var AGE_DISPLAY = { u35: 'under 35', '35_44': '35-44', '45_54': '45-54', '55p': '55+' };

  function getUtmParams() {
    var p = new URLSearchParams(location.search);
    return {
      utm_source: p.get('utm_source') || '',
      utm_medium: p.get('utm_medium') || '',
      utm_campaign: p.get('utm_campaign') || '',
      utm_content: p.get('utm_content') || '',
      utm_term: p.get('utm_term') || '',
      referrer: document.referrer || ''
    };
  }

  function buildQuizProperties(answers) {
    var concerns = answers.concerns || [];
    var primaryConcern = concerns[0] || '';
    var utm = getUtmParams();

    var props = {
      quiz_taken: 'ai-quiz-luxebeam',
      quiz_completed_at: new Date().toISOString(),
      primary_concern: primaryConcern,
      concern_display: CONCERN_DISPLAY[primaryConcern] || primaryConcern,
      all_concerns: concerns.join(', '),
      age_bracket: answers.age || '',
      age_display: AGE_DISPLAY[answers.age] || answers.age || '',
      routine: answers.routine || '',
      led_history: answers.tried || '',
      conditions: answers.conditions || '',
      consistency: answers.consistency || '',
      hesitation: answers.hesitation || ''
    };

    // Boolean per-concern properties for Klaviyo segment filtering
    ['fine_lines','firmness','dullness','texture','redness','dark_spots','prevention'].forEach(function(c) {
      props['has_concern_' + c] = concerns.indexOf(c) >= 0;
    });

    // Merge UTM
    Object.keys(utm).forEach(function(k) { props[k] = utm[k]; });
    return props;
  }

  function pushQuizToKlaviyo(email, answers) {
    if (!email || email.indexOf('@') < 0) return;
    var props = buildQuizProperties(answers);

    // 1. Klaviyo _learnq identify with ALL individual properties
    try {
      var identifyPayload = { $email: email };
      Object.keys(props).forEach(function(k) { identifyPayload[k] = props[k]; });
      window._learnq.push(['identify', identifyPayload]);
    } catch (e) { console.warn('[aiq] _learnq identify failed', e); }

    // 2. Klaviyo _learnq track 'Quiz Completed' with full payload
    try {
      window._learnq.push(['track', 'Quiz Completed', props]);
    } catch (e) { console.warn('[aiq] _learnq track failed', e); }

    // 3. Klaviyo Client API: subscribe to list with full profile properties
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'LMM AI Quiz - LuxeBeam',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: props
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
            }
          }
        })
      }).then(function(r) {
        console.log('[aiq] klaviyo subscribe', r.status);
      }).catch(function(e) {
        console.warn('[aiq] klaviyo subscribe failed', e);
      });
    } catch (e) { console.warn('[aiq] klaviyo subscribe error', e); }

    // 4. Klaviyo Client API: fire 'Quiz Completed' metric event
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Quiz Completed' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
              properties: props,
              value: 0,
              time: new Date().toISOString()
            }
          }
        })
      }).then(function(r) {
        console.log('[aiq] klaviyo event', r.status);
      }).catch(function(e) {
        console.warn('[aiq] klaviyo event failed', e);
      });
    } catch (e) { console.warn('[aiq] klaviyo event error', e); }
  }

  function postQuizCompletedEvent(email, answers) {
    if (!email || email.indexOf('@') < 0) return;
    var props = buildQuizProperties(answers);
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Quiz Completed' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
              properties: props,
              value: 0,
              time: new Date().toISOString()
            }
          }
        })
      }).then(function(r) {
        console.log('[aiq] postQuizCompletedEvent', r.status);
      }).catch(function(e) {
        console.warn('[aiq] postQuizCompletedEvent failed', e);
      });
    } catch (e) { console.warn('[aiq] postQuizCompletedEvent error', e); }
  }

  /*
   * fireTracking(event, data) — lifecycle event → platform mapping:
   *
   * 'email_capture'    → pushQuizToKlaviyo: identify + track 'Quiz Completed' + subscribe + event
   *                    → postQuizCompletedEvent: fires 'Quiz Completed' metric via /client/events
   *                    → Meta fbq 'Lead' ($247.50, AI Quiz - LuxeBeam)
   *
   * 'dossier_revealed' → Meta fbq 'ViewContent' (LuxeBeam Results Page)
   *                    → Klaviyo track 'Viewed Dossier'
   *
   * 'cta_clicked'      → Meta fbq 'InitiateCheckout' ($247.50, LuxeBeam Bundle)
   *                    → Klaviyo track 'Clicked CTA'
   *
   * All events         → console.log('[aiq]', event, data)
   */
  function fireTracking(event, data) {
    console.log('[aiq]', event, data);

    if (event === 'email_capture') {
      try { pushQuizToKlaviyo(data.email, data.answers); } catch (e) { console.warn('[aiq] pushQuizToKlaviyo error', e); }
      try { postQuizCompletedEvent(data.email, data.answers); } catch (e) { console.warn('[aiq] postQuizCompletedEvent error', e); }
      try { window.fbq('track', 'Lead', { content_name: 'AI Quiz - LuxeBeam', value: 247.50, currency: 'USD' }); } catch (e) {}
      // WeTracked: email captured
      wtqTrack('quiz_email_captured', Object.assign({ has_email: true }, getWtEventBase()));
    }

    if (event === 'dossier_revealed') {
      try { window.fbq('track', 'ViewContent', { content_name: 'LuxeBeam Results Page', content_type: 'product_recommendation' }); } catch (e) {}
      try { window._learnq.push(['track', 'Viewed Dossier', data]); } catch (e) {}
      // WeTracked: dossier shown
      wtqTrack('quiz_dossier_shown', Object.assign({ email_captured: !!state.email }, getWtEventBase()));
    }

    if (event === 'cta_clicked') {
      try { window.fbq('track', 'InitiateCheckout', { content_name: 'LuxeBeam Bundle', value: 247.50, currency: 'USD', num_items: 1 }); } catch (e) {}
      try { window._learnq.push(['track', 'Clicked CTA', data]); } catch (e) {}
      // WeTracked: PDP CTA clicked
      wtqTrack('quiz_pdp_cta_clicked', Object.assign({
        bundle_type: data.bundle || 'complete',
        has_discount: data.discount ? true : false,
        email_captured: !!state.email
      }, getWtEventBase()));
    }
  }


  // ======== Editor detection + in-chat image blocks ========
  function isEditorMode() {
    return (window.Shopify && window.Shopify.designMode) || document.body.classList.contains('shopify-design-mode');
  }

  function renderEditorMode() {
    document.body.classList.add('aiq-editor-mode');
    // Don't run the quiz flow — just show the page statically so merchant can edit.
    // Populate the chat stream with a preview of all configured blocks.
    if (!widgetEl || !streamEl) return;

    const previewNote = document.createElement('div');
    previewNote.style.cssText = 'background:#F4C89A; padding:10px 14px; border-radius:8px; font-size:12px; color:#3D2B1F; margin-bottom:16px;';
    previewNote.innerHTML = '<strong>⚙️ Editor preview mode.</strong> Customer sees these in sequence. All sections below are visible for editing. Save &amp; Preview to test the live flow.';
    streamEl.appendChild(previewNote);

    // Render all intro messages
    state.introMessages.forEach(msg => appendNode(aiMessage(msg)));

    // Render chat images (new chat_image block) inline
    const chatImages = widgetEl.querySelectorAll('[data-aiq-chat-image]');
    chatImages.forEach(imgWrap => {
      const src = imgWrap.dataset.aiqChatImage;
      const caption = imgWrap.dataset.aiqChatCaption || '';
      if (src) {
        const div = document.createElement('div');
        div.className = 'aiq-msg aiq-msg-image';
        div.innerHTML = '<div class="aiq-msg-avatar"></div><div><img src="' + src + '" alt="' + caption + '" />' + (caption ? '<div class="aiq-msg-image-caption">' + caption + '</div>' : '') + '</div>';
        streamEl.appendChild(div);
      }
    });

    // Render all questions
    state.questions.forEach((q, i) => {
      if (q.prompt) appendNode(aiMessage('<strong>Q' + (i+1) + ':</strong> ' + q.prompt));
    });
  }

  // ======== Boot ========
  function boot() {
    if (!readQuizConfig()) {
      console.warn('[aiq] no widget on page — quiz disabled');
      return;
    }
    if (isEditorMode()) {
      renderEditorMode();
      return;
    }
    // Live flow mode — gate the CSS hide rule
    document.body.classList.add('aiq-flow-mode');
    updateProgress();
    insertChatImagesForStep(0);
    const msgs = state.introMessages;
    if (!msgs.length) {
      console.warn('[aiq] no intro messages configured');
      startFirstQuestion();
      return;
    }
    // Play intro messages with typing delays
    let baseDelay = 800;
    msgs.forEach((msg, i) => {
      setTimeout(showTyping, baseDelay);
      baseDelay += (i === 0 ? 1400 : 1300);
      setTimeout(() => {
        removeTyping();
        appendNode(aiMessage(msg));
      }, baseDelay);
      baseDelay += (msg.length > 200 ? 2700 : 1600);
    });
    setTimeout(startFirstQuestion, baseDelay);
  }

  function startFirstQuestion() {
    setTimeout(showTyping, 1100);
    setTimeout(() => {
      removeTyping();
      state.step = 0;
      updateProgress();
      const q = state.questions[0];
      appendNode(aiMessage(q.prompt));
      setTimeout(() => renderChips(q), 280);
    }, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

// touch 1777445785
// touch 1777453829
// list-add 1777491469
